import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../constants/url";
import { CommonBody, Notification } from "../types/General";

type CommonResponseType = {
    statusCode: number;
    message: string;
};

type GetTokenParams = {
    page?: number;
    size?: number;
    query?: string;
};

type responce = {
    notification: Notification[];
    notificationCount: number;
    pages: number;
}

export const notificationApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        addNotification: builder.mutation<
            CommonResponseType & { data: Notification },
            CommonBody>({
                query: (body) => ({
                    url: END_POINTS.notification,
                    method: "POST",
                    body
                })
            }),

        getNotification: builder.query<
            CommonResponseType & { data: responce },
            GetTokenParams
        >({
            query: ({ query, page, size }) => ({
                url: `${END_POINTS.notification}?page=${page}&size=${size}&search=${query}`,
                method: "GET",
            })
        }),


        deleteNotification: builder.mutation<
            CommonResponseType & { data: Notification },
            { id: string | undefined }
        >({
            query: ({ id }) => ({
                url: `${END_POINTS.notification}/${id}`,
                method: "DELETE",
            }),
        }),

        getAdminNotification: builder.query<
            CommonResponseType & { data: responce },
            GetTokenParams
        >({
            query: ({ query, page, size }) => ({
                url: `${END_POINTS.adminNotification}?page=${page}&size=${size}&search=${query}`,
                method: "GET",
            })
        }),

        deleteAdminNotification: builder.mutation<
            CommonResponseType & { data: Notification },
            { id: string | undefined, clearAll: boolean }
        >({
            query: ({ id, clearAll }) => ({
                url: `${END_POINTS.adminNotification}/${id}`,
                method: "DELETE",
            }),
        }),
        deleteAllAdminNotification: builder.mutation<
            CommonResponseType & { data: responce },
            { clearAll: boolean }
        >({
            query: ({ clearAll }) => ({
                url: `${END_POINTS.adminNotification}?clearAll=${clearAll}`,
                method: "DELETE",
            }),
        }),
    })
})

export const {
    useAddNotificationMutation,
    useLazyGetNotificationQuery,
    useDeleteNotificationMutation,
    useLazyGetAdminNotificationQuery,
    useDeleteAdminNotificationMutation,
    useDeleteAllAdminNotificationMutation

} = notificationApi;